import styled from '@emotion/styled';
import media from 'css-in-js-media';

export const Grid = styled.div``;

export const Row = styled.div`
  width: ${props => `${props.width}px` || 'auto'};
  display: flex;
  flex-wrap: wrap;

  ${media('<desktop')} {
    flex-direction: column;
  }
`;
export const Col = styled.div`
  flex: ${props => props.size};
`;
